import { render, staticRenderFns } from "./sameGoods.vue?vue&type=template&id=72a46e4b&scoped=true&"
import script from "./sameGoods.vue?vue&type=script&lang=js&"
export * from "./sameGoods.vue?vue&type=script&lang=js&"
import style0 from "./sameGoods.vue?vue&type=style&index=0&id=72a46e4b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a46e4b",
  null
  
)

export default component.exports